import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import { useEffect, useState } from "react";
import SelectBaseAntd from "../SelectBaseAntd";
import { SelectBaseAntdProps } from "../SelectBaseAntd/index";
import ModalGrupoDesconto from "components/Features/GrupoDesconto/ModalGrupoDesconto";
import useGruposDesconto from "core/features/grupo-desconto/hooks/useGruposDesconto";
import { useCurrentTenant } from "core/features/auth/tenant.store";

export interface SelectGrupoDescontoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
}

function SelectGrupoDesconto({
  value,
  onChange,
  isInvalid,
  ...rest
}: SelectGrupoDescontoProps) {
  const { tenant } = useCurrentTenant();
  const { isLoading, isFetching, data, refetch } = useGruposDesconto(
    {
      page: 1,
      limit: 9999,
    },
    tenant.id
  );
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
    }
  }, [isOpenModal]);
  return (
    <>
      <ModalGrupoDesconto
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSaved={async (id) => {
          onChange(id);

          refetch();

          setIsOpenModal(false);
        }}
      />

      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        disabled={isLoading || isFetching}
        size="large"
        placeholder="Selecione..."
        value={value || undefined}
        onChange={onChange}
        {...rest}
        showSearch
        searchValue={search}
        onSearch={(v) => {
          if (!isOpenModal) {
            setSearch(v);
          }
        }}
        optionFilterProp="label"
        options={data?.items.map((item) => ({
          value: item.id,
          label: item.nome,
        }))}
        notFoundContent={
          !isLoading && !isFetching ? (
            <Box>
              Nada encontrado!!{" "}
              <Button
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar novo
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectGrupoDesconto;
